export default {
  title: {
    id: 'merchant_onboarding_home_page_title',
    defaultMessage: "Welcome, { sellerName }. Let's get started!",
  },
  pageTitle: {
    id: 'bo_seller-homepage-page_title',
    defaultMessage: 'Home',
  },
  subtitle: {
    id: 'merchant_onboarding_home_page_subtitle',
    defaultMessage:
      'Tackle your to-do list below to become a bona fide Back Market seller.',
  },
}
